<template>
  <tr>
    <td>{{site.identifier}}</td>
    <td>
      <div class="addressContainer">
        <div v-if="site.address_street1" class="street1">{{site.address_street1}}</div>
        <div v-if="site.address_street2" class="street2">{{site.address_street2}}</div>
        <div class="cityStateZip">{{site.address_city}}, {{site.address_state}} {{site.address_zip}}</div>
      </div>
    </td>
    <td><span v-if="legalEntity">{{legalEntity}}</span><span v-else class="text-muted">N/A</span></td>
    <td style="border-right: none;" :colspan="actionColCount">
      <div class="addressContainer">
        <div v-if="fullName">{{fullName}}</div>
        <div v-if="addressStreet1" class="street1">{{addressStreet1}}</div>
        <div v-if="addressStreet2" class="street2">{{addressStreet2}}</div>
        <div v-if="addressCity || addressStateName || addressZIP" class="cityStateZip">{{addressCity}}, {{addressStateName}} {{addressZIP}}</div>
      </div>
    </td>
    <td v-if="editable" width=25>
      <button v-on:click.prevent class="btn btn-md btn-primary" data-bs-toggle="modal" :data-bs-target="'#' + modalName">Edit</button>

      <!-- Modal -->
      <div class="modal fade" :id="modalName" tabindex="-1" :aria-labelledby="modalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" :id="modalLabel">Billing Contact Details</h5>
            </div>
            <div class="modal-body">
              <div class="row row-cols-2">
                <div class="col">
                  <!-- Full name -->
                  <div class="mb-3">
                    <label>Full Name</label>
                    <input type="text" :name="fieldName('billing_poc_name')" class="form-control form-control-sm" placeholder="Full Name" v-model="fullName" />
                  </div>

                  <!-- Legal entity name -->
                  <div class="mb-3">
                    <label>Legal Entity Name</label>
                    <input type="text" :name="fieldName('legal_entity')"  class="form-control form-control-sm" placeholder="Legal Entity Name" v-model="legalEntity" />
                  </div>

                  <!-- Phone number -->
                  <div class="mb-3">
                    <label>Phone Number</label>
                    <input type="tel" :name="fieldName('billing_poc_phone')"  class="form-control form-control-sm" placeholder="Phone Number" v-model="phone" />
                  </div>

                  <!-- Email address -->
                  <div class="mb-3">
                    <label>Email Address</label>
                    <input type="email" :name="fieldName('billing_poc_email')"  class="form-control form-control-sm" placeholder="Email Address" v-model="email" />
                  </div>
                </div>

                <div class="col">
                  <!-- Street 1 -->
                  <div class="mb-3">
                    <label>Address Line 1</label>
                    <input type="text" :name="fieldName('address_street1')"  class="form-control form-control-sm" placeholder="Address Line 1" v-model="addressStreet1" />
                  </div>

                  <!-- Street 2 -->
                  <div class="mb-3">
                    <label>Address Line 2</label>
                    <input type="text" :name="fieldName('address_street2')"  class="form-control form-control-sm" placeholder="Address Line 2" v-model="addressStreet2" />
                  </div>

                  <!-- City -->
                  <div class="mb-3">
                    <label>City</label>
                    <input type="text" :name="fieldName('address_city')" class="form-control form-control-sm" placeholder="City" v-model="addressCity" />
                  </div>

                  <div class="row row-cols-2">
                    <!-- State -->
                    <div class="mb-3 col">
                      <label>State</label>
                      <select v-model="addressStateID" :name="fieldName('address_state_id')" class="form-control form-control-sm">
                        <option value="">--</option>
                        <option v-for="state in states" :key="state.id" :value="state.id">
                          {{state.subdivisionIsoCode}}
                        </option>
                      </select>
                    </div>

                    <!-- ZIP -->
                    <div class="mb-3 col">
                      <label>ZIP Code</label>
                      <input type="number" :name="fieldName('address_zip')"  class="form-control form-control-sm" placeholder="Zip Code" v-model="addressZIP" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Save</button>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    editable: { type: Boolean, default: true },
    site: { type: Object, required: true },
    billingContact: { type: Object, required: false },
    states: { type: Array, required: false },
  },
  data: function() {
    return {
      fullName: '',
      legalEntity: '',
      phone: '',
      email: '',
      addressStreet1: '',
      addressStreet2: '',
      addressCity: '',
      addressStateID: '',
      addressStateName: '',
      addressZIP: '',
    };
  },
  computed: {
    actionColCount: function() { return (this.editable) ? 1 : 2; },
    // legalEntityName: function() {
    //   return (this.legalEntity) ? this.legalEntity : (this.site.legal_entity) ? this.site.legal_entity.name : (this.site.legal_entity_name) ? this.site.legal_entity_name : false;
    // },
    modalName: function() { return this.refName + '-modal'; },
    modalLabel: function() { return this.refName + '-modelLabel'; },
    refName: function() { return 'site-' + this.site.id; },
  },
  methods: {
    fieldName: function(name) {
      return 'site[' + this.site.id + '][' + name + ']';
    },
  },
  mounted: function() {
    // If an old billing contact was passed in, set the data
    if(this.billingContact) {
      if(this.billingContact.billing_poc_name) this.fullName = this.billingContact.billing_poc_name;
      if(this.billingContact.billing_poc_phone) this.phone = this.billingContact.billing_poc_phone;
      if(this.billingContact.billing_poc_email) this.email = this.billingContact.billing_poc_email;
      if(this.billingContact.address_street1) this.addressStreet1 = this.billingContact.address_street1;
      if(this.billingContact.address_street2) this.addressStreet2 = this.billingContact.address_street2;
      if(this.billingContact.address_city) this.addressCity = this.billingContact.address_city;
      if(this.billingContact.address_state_id) this.addressStateID = this.billingContact.address_state_id;
      if(this.billingContact.address_zip) this.addressZIP = this.billingContact.address_zip;

      // Handle legal entity
      // If a site has a pre-set legal entity name, use that name.
      // If the site has a legal entity attached, use that name.
      if(this.billingContact.legal_entity) this.legalEntity = this.billingContact.legal_entity.name;
    }
    if(this.site.legal_entity_name) this.legalEntity = this.site.legal_entity_name;
    if(this.site.legal_entity) this.legalEntity = this.site.legal_entity.name;
  },
  watch: {
    addressStateID: function() {
      // Find the state object in the states array and set the values to display correctly
      this.states.forEach(state => {
        if(state.id == this.addressStateID) {
          this.addressStateName = state.subdivisionIsoCode;
        }
      });
    },
  },
}
</script>